import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  FinancialOiExportDocument,
  type FinancialOiExportQuery,
  type FinancialOiExportQueryVariables,
} from "@src/__generated__/urql-graphql";
import { ModalInputDatePicker } from "@src/components/ui-kit";
import { client } from "@src/services/client";
import type { DateRange as Range } from "@src/utils/types";
import { observer } from "mobx-react-lite";

export const ExportFinancialDocumentsButton = observer(
  function ExportFinancialDocumentsButton() {
    const modal = useDisclosure();

    const onSelectDate = async (range: Range) => {
      const { data } = await client
        .query<FinancialOiExportQuery, FinancialOiExportQueryVariables>(
          FinancialOiExportDocument,
          {
            from: range.start,
            to: range.end,
          },
        )
        .toPromise();
      if (!data?.financialOIExport) return;
      window.location.href = data.financialOIExport;
    };

    return (
      <MenuItem onClick={modal.onOpen}>
        <Trans>Financial export (Helios)</Trans>
        <ModalInputDatePicker
          {...modal}
          allowRange
          title={t`Choose start and end date`}
          onConfirm={onSelectDate}
          confirmLabel={t`Generate`}
        />
      </MenuItem>
    );
  },
);
